module.exports = __webpack_public_path__ + "static/haas-gray-877a0f757e6d6b4e3ee1b9d80173616e.png";